import { render, staticRenderFns } from "./fee-discount-type-select.component.vue?vue&type=template&id=e134e824&scoped=true&"
import script from "./fee-discount-type-select.component.vue?vue&type=script&lang=ts&"
export * from "./fee-discount-type-select.component.vue?vue&type=script&lang=ts&"
import style0 from "./fee-discount-type-select.component.vue?vue&type=style&index=0&id=e134e824&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e134e824",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
